export default "__VITE_ASSET__CZS3SCyL__"